import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { ATTACHMENTS_HANDLER_CONFIG } from '../config/attachments-handler.config';
import type { DocMatrixResponse, LinkedFileItem, LinkPayload, UnlinkPayload } from '../models/api';

@Injectable({ providedIn: 'root' })
export class DocMatrixService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = inject(ATTACHMENTS_HANDLER_CONFIG).apiUrl;

    loadDocMatrix(): Observable<DocMatrixResponse> {
        return this.http.get<DocMatrixResponse>(`${this.baseUrl}configuration/docmatrix`);
    }

    setDocMatrixConfig(type: string, id: number): Observable<unknown> {
        return this.http.post(`${this.baseUrl}configuration/docmatrix`, {
            sourcemodel_type: type,
            sourcemodel_id: id,
        });
    }

    loadAllLinks(type: string, id: number): Observable<LinkedFileItem[]> {
        return this.http.get<LinkedFileItem[]>(`${this.baseUrl}docmatrix-file-links/links/${type}/${id}`);
    }

    loadLinkedFiles(type: string, id: number, itemUuid: string): Observable<LinkedFileItem[]> {
        return this.http.get<LinkedFileItem[]>(`${this.baseUrl}docmatrix-file-links/links/${type}/${id}/item/${itemUuid}`);
    }

    linkFiles(payloads: LinkPayload[]): Observable<unknown[]> {
        return forkJoin(payloads.map((payload) => this.http.post(`${this.baseUrl}docmatrix-file-links/link`, payload)));
    }

    unlinkFiles(payloads: UnlinkPayload[]): Observable<unknown[]> {
        return forkJoin(payloads.map((payload) => this.http.post(`${this.baseUrl}docmatrix-file-links/unlink`, payload)));
    }
}
